module.exports = __webpack_public_path__ + "img/JJH_Android.a4ab7f6c.png";